import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {selectCompanies, selectSelectedCompany, switchCompany} from "store/companySlice";
import {clearCurrentBoard} from "store/currentBoardSlice";
import {resetBoards} from "store/boardsSlice";
import {resetOnboarding} from "store/onboardingSlice";

import Icon from "layout/atoms/Icon";
import {ReactComponent as LogoSvg} from "assets/logo.svg";

import {CompanyButton, CompanyInitials, LogoContainer, Wrapper} from "./styles";

const CompanySwitcher = ({ isActive }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const companies = useSelector(selectCompanies);
  const selectedCompany = useSelector(selectSelectedCompany);

  // Debug logging
  console.log('CompanySwitcher - isActive:', isActive);
  console.log('CompanySwitcher - companies:', companies);
  console.log('CompanySwitcher - selectedCompany:', selectedCompany);

  const getInitials = (name) => {
    if (!name) return "?";
    const words = name.trim().split(/\s+/);
    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }
    return (words[0][0] + words[1][0]).toUpperCase();
  };

  const handleCompanyClick = async (company) => {
    // Don't switch if already selected
    if (selectedCompany?.companyId === company.companyId) {
      return;
    }

    // Clear current board
    dispatch(clearCurrentBoard());

    // Fetch detailed company info when switching (this updates the companyId in state)
    await dispatch(switchCompany(company.companyId));

    // NOW reset boards and onboarding AFTER company switch is complete
    // This ensures components will fetch with the NEW companyId
    dispatch(resetBoards());
    dispatch(resetOnboarding());

    // Navigate to boards page (or stay there if already there)
    // The BoardsList component will auto-fetch when it sees boardStatus === "idle"
    // The OnboardingChecklist component will also auto-fetch when it sees status === "idle"
    navigate('/admin/boards');
  };

  // Handle empty companies array
  if (!companies || companies.length === 0) {
    console.log('CompanySwitcher - No companies available');
    return <Wrapper active={isActive}></Wrapper>;
  }

  return (
    <Wrapper active={isActive}>
      <LogoContainer>
        <Icon src={LogoSvg} size="35px" />
      </LogoContainer>
      {companies.map((company) => (
        <CompanyButton
          key={company.companyId}
          isSelected={selectedCompany?.companyId === company.companyId}
          onClick={() => handleCompanyClick(company)}
          title={company.companyName}
        >
          <CompanyInitials>{getInitials(company.companyName)}</CompanyInitials>
        </CompanyButton>
      ))}
    </Wrapper>
  );
};

export default CompanySwitcher;